export abstract class GeneralError extends Error {
  public constructor(message?: string | undefined) {
    super(message);
    this.name = this.constructor.name;
  }
}
